export { getServerSideProps } from '~/components/pages/SitterProfile/serverSideProps/getServerSideProps';
export { SitterProfile as default } from '~/components/pages/SitterProfile/SitterProfile';
